export default __webpack_public_path__ + "static/media/style5.ac07dcd1.jpeg";